import css from "standard/css";

const style = css`
  :root {
    --opacity-level-semiopaque: 0.72;
    --opacity-level-intense: 0.64;
    --opacity-level-medium: 0.32;
    --opacity-level-light: 0.16;
    --opacity-level-semitransparent: 0.08;
  }
`;

export default style;
